import Axios, { AxiosInstance, AxiosResponse } from 'axios';
import History from '../../routing/History';
import { toastr } from 'react-redux-toastr';
import IFetchConfiguration from './IFetchConfiguration';
import { getEnvironmentConfig } from './environmentConfig';

const configureFetch = (
  { interceptIgnoreStatusErrorCodes = [] }: IFetchConfiguration = {},
) : Promise<AxiosInstance> => {

  // Resolve environment config on first call and cache in sessionStorage
  let baseUrl = sessionStorage.getItem('settings.apiUrl');

  if (baseUrl === null) {
    const envConfig = getEnvironmentConfig(window.location.hostname);
    baseUrl = envConfig.apiLocation;
    sessionStorage.setItem('settings.apiUrl', baseUrl);
    sessionStorage.setItem('settings.apiConfig', JSON.stringify(envConfig.configSettings));
  }

  const token = localStorage.getItem('token');

  const headers : any = {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
  };

  if (token !== null && token !== '') {
    const key : (keyof any) = 'Authorization';
    headers[key] = `Bearer ${token}`;
  }

  const inst = Axios.create({
    headers,
    baseURL: baseUrl,
  });

  inst.interceptors.response.use(
    (response: AxiosResponse<any>) => {
      return response;
    },
    (error: any) => {

      if (interceptIgnoreStatusErrorCodes &&
        !interceptIgnoreStatusErrorCodes.includes(error.response.status)) {

        if (error.response.status === 401) {
          History.push(`${ window.location.pathname.indexOf('/admin') === 0 ? '/admin' : ''}/login`);
        } else {
          const errorMessage = `There was an error processing your request.
          Please try again or contact support if this persists.`;

          toastr.error(
            'Request error',
            errorMessage);
        }
      }

      return error;
    });

  return Promise.resolve(inst);
};

export default (config?: IFetchConfiguration) => {
  return configureFetch(config);
};
